export default __webpack_public_path__ + "static/media/how-asset-allocation.4fd2f1e1.png";